export class SessionStorage {
  static readonly HighestRoleId = 'HighestRoleId';
  static readonly IscookiesettingsButton = 'iscookiesettingsclicked';
  static readonly Language ='lang';
  static readonly PreviousOptanonValue = 'PreviousOptanonValue';
  static readonly IdToken = 'IdToken';
}
